export const hasCompleteUserInfo = (userData) => {
    return (!!(userData === null || userData === void 0 ? void 0 : userData.email) &&
        !!(userData === null || userData === void 0 ? void 0 : userData.firstName) &&
        !!(userData === null || userData === void 0 ? void 0 : userData.lastName) &&
        !!(userData === null || userData === void 0 ? void 0 : userData.phoneNumber));
};
